import { Box } from '@mui/material'
import React, { memo, useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { useAppSelector } from '../../../app/hooks'
import { useGetCustomersQuery } from '../../../app/redux-fetch/apiQuery'
import { IDropDownItem } from '../../../app/types'
import FormInput from '../../../components/Forms/FormInput'
import FormSelect from '../../../components/Forms/FormSelect'
import {
  SectionTitleTypography
} from '../../../components/Typographies/styles'
import { fetchLoggedInUserSelector } from '../../selectors'
import { ILoggedInUser } from '../../types'

import messages from './messages'

interface MainInfoProps {
  readonly isDisabled?: boolean
  readonly isEdit?: boolean
}

const MainInfo: React.FC<MainInfoProps> = memo(({
  isDisabled = false,
}) => {
  const { formatMessage } = useIntl()
  const { control } = useFormContext()

  const loggedInUser = useAppSelector(fetchLoggedInUserSelector.data) || ({} as ILoggedInUser)
  const { data: customers = [] } = useGetCustomersQuery(loggedInUser.tenantId ?? -1)

  const isCustomerUser = loggedInUser?.customerId && loggedInUser?.tenantId

  const customerOptions = useMemo(() =>
    (customers as IDropDownItem[]).map((c) => ({ value: c.id, label: c.name })),
    [customers]
  )

  return (
    <Box sx={{ width: '50%' }}>
      <Box sx={{ mb: '16px' }}>
        <SectionTitleTypography>
          {formatMessage(messages.mainInfoTitle)}
        </SectionTitleTypography>
      </Box>

      {!isCustomerUser && (
        <Box sx={{ mb: '8px' }}>
          <Controller
            name='customerId'
            control={control}
            render={({ field, fieldState }) => (
              <FormSelect
                name='customerId'
                label={formatMessage(messages.customerLbl)}
                options={customerOptions}
                value={field.value}
                onChange={field.onChange}
                disabled
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </Box>
      )}

      <Box sx={{ mb: '8px' }}>
        <FormInput
          name='name'
          label={formatMessage(messages.name)}
          required
          disabled={isDisabled}
          maxLength={250}
        />
      </Box>
    </Box>
  )
})

MainInfo.displayName = 'MainInfo'

export default MainInfo
